import {Component, Input} from "@angular/core";
import {GlobalSearchService} from "@core/globalSearch/globalSearch.service";

enum SEARCH_STATUS {
  START = "start",
  IN_PROGRESS = "inprogress",
  DONE = 'done'
}

@Component({
  selector: 'global-search-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.less']
})

export class GlobalSearchPanelComponent {
  @Input()
  public searchText: string;
  public results: any[] = [];
  public resultsCount: number = undefined;
  public searchStatus: SEARCH_STATUS = SEARCH_STATUS.START;

  public open: boolean = false;

  constructor(private globalSearchService: GlobalSearchService) {
  }

  isOpen() {
    return this.open;
  }

  close() {
    this.open = false;
  }

  search(text) {
    this.searchText = text;

    this.results = [];
    this.resultsCount = undefined;
    if (text.length > 2) {
      this.searchStatus = SEARCH_STATUS.IN_PROGRESS;
      this.globalSearchService.search(text, 25)
        .then(results => {
          this.results = results.results;
          this.resultsCount = results.count;
          this.searchStatus = SEARCH_STATUS.DONE;
        });
    } else {
      this.searchStatus = SEARCH_STATUS.START;
    }
  }

  onSearchTextChange(text) {
    this.search(text);
  }

  onRowClick(item) {
    this.close();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/globalSearch/panel/panel.component.ts